import React, { useState, useEffect } from "react";
import {
  Formik,
  FieldArray,
  Field,
  useFormikContext,
  ErrorMessage,
} from "formik";
import { PlusIcon as PlusIcon } from "@heroicons/react/24/solid";
import { TrashIcon as TrashIconMini } from "@heroicons/react/20/solid";
import _ from "lodash";
import DiagnosisSearchNSelect from "./DiagnosisSearchNSelect";
import { Button, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import AppButton from "../../../../shared/AppButton";

function Diagnosis({ onChange, refId, selectedPatient = null }) {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
  } = useFormikContext();
  const { t, i18n } = useTranslation();
  const addData = (values) => {
    let data = _.cloneDeep(values);
    // createInsurancePlan({ variables: { input: data } });
  };

  useEffect(() => {
    if (!values.diagnosisArr || values.diagnosisArr.length === 0) {
      setFieldValue("diagnosisArr", [
        {
          id: 1,
          codeDescription: "",
          type: "principal",
          on_admission: false,
          codeId: "",
        },
      ]);
    }
  }, [values.diagnosisArr, setFieldValue]);

  const tableHeaders = [
    {
      name: "Code - Description",
    },
    {
      name: "Type",
    },
    {
      name: "On Admission",
    },
    {
      name: "",
    },
  ];

  const diagnosisTypes = [
    { id: "principal", name: "Principal Diagnosis" },
    { id: "secondary", name: "Secondary Diagnosis" },
    { id: "admitting", name: "Admitting Diagnosis" },
    { id: "discharge", name: "Discharge Diagnosis" },
    { id: "differential", name: "Differential Diagnosis" },
  ];

  const formikRef = React.useRef();
  React.useImperativeHandle(refId, () => ({
    Submit: async () => {
      await formikRef.current.submitForm();
    },
  }));

  function watchForm(data) {
    if (onChange) {
      onChange({
        values: data,
      });
    }
  }

  return (
    <FieldArray name="diagnosisArr">
      {({ push, remove }) => {
        return (
          <>
            <div class="care_teams !p-2" id="careTeams2">
              <div class="flex_cont !mb-2">
                <div class="personal-title">
                  <div class="inventory-svg">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="34" height="34" rx="8" fill="#F4F6F8"></rect>
                      <path
                        d="M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z"
                        fill="#0070C2"
                      ></path>
                      <path
                        d="M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z"
                        fill="#0070C2"
                      ></path>
                    </svg>
                  </div>
                  <div class="personal-head">
                    <span>{t("Diagnosis *")}</span>
                  </div>
                </div>
                <div>
                  <AppButton
                    label={t("Add Diagnosis")}
                    startIcon={<AddIcon />}
                    onClick={() =>
                      values.diagnosisArr.length === 0
                        ? push({
                            id: values.diagnosisArr.length + 1,
                            codeDescription: "",
                            type: "principal",
                            on_admission: false,
                            codeId: "",
                          })
                        : push({
                            id: values.diagnosisArr.length + 1,
                            codeDescription: "",
                            type: "secondary",
                            on_admission: false,
                            codeId: "",
                          })
                    }
                  />
                </div>
              </div>
              <div class="pre_auth_communication_table">
                <div className="">
                  <div className="" id="tableBody">
                    {values.diagnosisArr.map((item, index) => {
                      return (
                        <div
                          key={"addressform"}
                          className="personal-data !p-2 !mb-2 last:!mb-0 relative"
                        >
                          <div className="personal-fields grid grid-cols-1 md:grid-cols-3 gap-1.5">
                            <div className="flex flex-col justify-between h-full w-full">
                              <div className="flex flex-nowrap items-center gap-1 mb-0.5 w-full overflow-hidden">
                                <label className="font-semibold text-[12px] text-gray-700 capitalize shrink-0">
                                  {t("Code-Description")}
                                </label>

                                {(values.diagnosisArr[index]?.codeDescription ||
                                  values.diagnosisArr[index]?.codeId) && (
                                  <div className="min-w-0 flex-1 overflow-hidden">
                                    <Tooltip
                                      title={`${values.diagnosisArr[index]?.codeDescription} - ${values.diagnosisArr[index]?.codeId}`}
                                      arrow
                                    >
                                      <span
                                        className="text-[10px] text-gray-500 cursor-default block"
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        (
                                        {
                                          values.diagnosisArr[index]
                                            ?.codeDescription
                                        }{" "}
                                        - {values.diagnosisArr[index]?.codeId})
                                      </span>
                                    </Tooltip>
                                  </div>
                                )}
                              </div>
                              <div>
                                <DiagnosisSearchNSelect
                                  setFieldValue={(val) => {
                                    setFieldValue(
                                      `diagnosisArr.${index}.codeDescription`,
                                      val.AsciiDescription,
                                    );
                                    setFieldValue(
                                      `diagnosisArr.${index}.codeId`,
                                      val.CodeId,
                                    );
                                  }}
                                  values={values}
                                  index={index}
                                  selectedPatient={selectedPatient}
                                />
                                <ErrorMessage
                                  name={`diagnosisArr.${index}.codeDescription`}
                                  component="div"
                                  className="text-red-500 text-xs"
                                />
                              </div>
                            </div>
                            <div className="flex flex-col justify-between h-full w-full">
                              <label className="font-semibold text-[12px] text-gray-700 mb-0.5 capitalize shrink-0">
                                {t("Type")}
                              </label>
                              <div>
                                <Field
                                  className="insurance-plans-select"
                                  as="select"
                                  name={`diagnosisArr.${index}.type`}
                                >
                                  <option value="">
                                    <p>{t("Please Select")}</p>
                                  </option>
                                  {diagnosisTypes.map((item) => {
                                    return (
                                      <option value={item.id} key={item.id}>
                                        {item.name}
                                      </option>
                                    );
                                  })}
                                </Field>
                                <ErrorMessage
                                  name={`diagnosisArr.${index}.type`}
                                  component="div"
                                  className="text-red-500 text-xs"
                                />
                              </div>
                            </div>

                            <div className="flex flex-col justify-between h-full w-full">
                              <label className="font-semibold text-[12px] text-gray-700 mb-0.5 capitalize shrink-0">
                                {t("On Admission")}
                              </label>
                              <div>
                                <Field
                                  className="insurance-plans-select"
                                  as="select"
                                  name={`diagnosisArr.${index}.on_admission`}
                                >
                                  <option value="">{t("On Admission")}</option>
                                  <option value={true}>{t("Yes")}</option>
                                  <option value={false}>{t("No")}</option>
                                </Field>

                                <ErrorMessage
                                  name={`diagnosisArr.${index}.on_admission`}
                                  component="div"
                                  className="text-red-500 text-xs"
                                />
                              </div>
                            </div>

                            {values?.claimType === "institutional" && (
                              <div className="flex flex-col justify-between h-full w-full">
                                <label className="font-semibold text-[12px] text-gray-700 mb-0.5 capitalize shrink-0">
                                  {t("Condition Onset")}
                                </label>
                                <div>
                                  <Field
                                    className="insurance-plans-select"
                                    as="select"
                                    name={`diagnosisArr.${index}.condition_on_set`}
                                  >
                                    <option value={null}>
                                      {t("Condition Onset")}
                                    </option>
                                    <option value={"COEA"}>
                                      {t(
                                        "Condition with onset during the episode of admitted patient care",
                                      )}
                                    </option>
                                    <option value={"CNNA"}>
                                      {t(
                                        "Condition not noted as arising during the episode of admitted patient care",
                                      )}
                                    </option>
                                    <option value={"NR"}>
                                      {t("Not reported")}
                                    </option>
                                  </Field>

                                  <ErrorMessage
                                    name={`diagnosisArr.${index}.condition_on_set`}
                                    component="div"
                                    className="text-red-500 text-xs"
                                  />
                                </div>
                              </div>
                            )}

                            {values.diagnosisArr.length > 1 && (
                              <div className="cursor-pointer absolute top-0 right-0">
                                <div
                                  class="remove-row"
                                  onClick={() => remove(index)}
                                >
                                  <svg
                                    width="22"
                                    height="22"
                                    viewBox="0 0 38 38"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle
                                      cx="19"
                                      cy="19"
                                      r="19"
                                      fill="#fee2e2"
                                    />
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M26 20H12C11.448 20 11 19.553 11 19C11 18.447 11.448 18 12 18H26C26.553 18 27 18.447 27 19C27 19.553 26.553 20 26 20Z"
                                      fill="#dc2626"
                                    />
                                    <mask
                                      id="mask0_235_11306"
                                      style={{
                                        WebkitMaskType: "luminance",
                                        maskType: "luminance",
                                      }}
                                      maskUnits="userSpaceOnUse"
                                      x="11"
                                      y="18"
                                      width="16"
                                      height="2"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M26 20H12C11.448 20 11 19.553 11 19C11 18.447 11.448 18 12 18H26C26.553 18 27 18.447 27 19C27 19.553 26.553 20 26 20Z"
                                        fill="#dc2626"
                                      />
                                    </mask>
                                    <g mask="url(#mask0_235_11306)"></g>
                                  </svg>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              {errors.diagnosisArr &&
              touched.diagnosisArr &&
              typeof errors.diagnosisArr === "string" ? (
                <div className="max-w-2xl mt-2 text-sm leading-6">
                  <p className="text-red-500">{errors.diagnosisArr}</p>
                </div>
              ) : null}
            </div>
          </>
        );
      }}
    </FieldArray>
  );
}

export default Diagnosis;
